<template>
  <el-dialog title="选择图片" width="800px" :visible.sync="visible" :append-to-body="true">
    <div class="picture-card-list-wrapper">
      <div class="avatar-item" :style="`width:${size};height:${size};`" v-for="(item, i) in imgs" :key="i" @click="choose(item)">
        <el-image :src="item" class="avatar-item-img" fit="contain"></el-image>
        <el-checkbox class="top-left" label="" :value="item === selectImg" @change.native.stop="choose(item)"></el-checkbox>
      </div>
      <el-upload
        action=""
        class="avatar-uploader avatar-item"
        :style="`width:${size};height:${size};`"
        :show-file-list="false"
        :multiple="multiple"
        :on-change="handleFileChange"
        :http-request="uploadFile"
        :before-upload="beforeAvatarUpload"
      >
        <template v-if="loading">
          <el-progress :show-text="false" :stroke-width="1" :percentage="process" color="#3a416f"></el-progress>
        </template>
        <template v-else>
          <span class="up-icon">+</span>
        </template>
      </el-upload>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button class="el-button--small f-btn" type="primary" @click="confirm" :disabled="!selectImg">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { uploadFileDirect } from '@/server/common'
export default {
  name: 'picture-upload',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {},
    size: {
      default: '80px'
    },
    folder: {
      default: 'default'
    },
    multiple: {
      default: true
    },
    images: {
      default: () => []
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('change', val)
      if (val) this.imgs = this.images
    }
  },
  data() {
    return {
      loading: false,
      imgs: [],
      timmer: null,
      process: 0,
      file: undefined,
      visible: false,
      selectImg: ''
    }
  },
  mounted() {},

  methods: {
    choose(url) {
      if (url === this.selectImg) this.selectImg = ''
      else this.selectImg = url
    },
    handleFileChange(file) {
      this.file = file.raw
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isPng = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!(isJPG || isPng)) {
        this.$message.error(this.$t('stores::products-info::upload-type-tips'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('stores::products-info::upload-size-tips'))
      }
      return (isJPG || isPng) && isLt2M
    },
    beforeDestroy() {
      if (this.timmer) {
        clearInterval(this.timmer)
        this.timmer = null
      }
    },
    processInt(bool) {
      this.process = 0
      const ddom = Math.random(5, 10) * 10 + 5
      this.timmer = setInterval(() => {
        const rdom = Math.random(0, 10) * 10
        this.process += parseInt(rdom)
        if (bool) {
          if (this.process >= 90) {
            this.process = 90 + ddom
          }
        } else {
          this.process = 100
          clearInterval(this.timmer)
        }
        if (this.process > 100) {
          this.process = 100
          clearInterval(this.timmer)
        }
      }, 100)
    },
    async uploadFile() {
      this.loading = true
      this.processInt(this.loading)
      const { data } = await uploadFileDirect(this.file, this.folder)
      setTimeout(() => {
        this.loading = false
      }, 1000)
      if (data.code === this.$code) {
        this.imgs.push(data.data.absolutePath)
      } else {
        this.$message.error(data.msg)
      }
    },
    confirm() {
      this.$emit('select', this.selectImg)
      this.visible = false
      this.selectImg = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.picture-card-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  .avatar-uploader {
    ::v-deep {
      .el-upload {
        box-sizing: border-box;
        padding: 4px;
        width: 100%;
        height: 100%;
        margin-right: 8px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        color: #3a416f;
        .up-icon {
          display: flex;
          align-items: center;
          flex-direction: column;
          font-size: 30px;
        }
        .el-progress {
          width: 100%;
          .el-progress-bar__outer {
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
  .avatar-item-img {
    width: 100%;
    height: 100%;
  }
  .avatar-item {
    position: relative;
    width: 80px;
    overflow: hidden;
    margin-top: 5px;
    margin-right: 5px;
    height: 80px;
    display: block;
    .top-left {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
